module.exports = __webpack_public_path__ + "media/sofia/sofia-info-3d-10202829.png";